import script from "./form_running_text.vue?vue&type=script&setup=true&lang=ts"
export * from "./form_running_text.vue?vue&type=script&setup=true&lang=ts"

import "./form_running_text.vue?vue&type=style&index=0&id=10d85f64&scoped=true&lang=css"

import exportComponent from "/home/kuradmin/frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10d85f64"]])

export default __exports__